import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import ShowList from "./components/pages/ShowList.js";
// import Form  from "./components/Form.js";

// const myComponent = <form />;

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(  
<React.StrictMode>
    {/* <Form /> */}
    <ShowList />
  </React.StrictMode>
  );


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

